import styled from "styled-components";
import { Text } from "@gcs/design-system/react";

export const SectionSponsorshipPolicyContainer = styled.section(
  ({ theme }) => ({
    paddingTop: "40px",
    paddingBottom: "40px",

    [theme.breakpoint.lg()]: {
      paddingTop: "60px",
      paddingBottom: "60px",
    },
  })
);

export const SectionIntergrityProgramText = styled(Text)(({ theme }) => ({
  fontSize: "18px",
  fontWeight: "500",
  lineHeight: "160%",

  [theme.breakpoint.lg()]: {
    fontSize: "20px",
  },
}));

export const SectionSponsorshipPolicyList = styled.ul(() => ({
  padding: "0",
  listStyle: "none",
}));
